import styled from "styled-components"

interface ButtonsProps {
  bg?: string
  color?: string
  border?: string
  visible?: boolean
  height?: number
  width?: number
}
export const Primary = styled.button`
  background-color: ${(p: ButtonsProps) => (p.bg ? p.bg : "var(--color-rosa)")};
  color: ${(p: ButtonsProps) => (p.color ? p.color : "#fbfbfbf9")};
  border: none;
  border-radius: 52px;
  height: ${(p: ButtonsProps) => p.height || "65"}px;
  width: ${(p: ButtonsProps) => p.width + "px" || "100%"};
  font: normal normal bold 30px/37px MontserratRegular;
  font-size: clamp(0.9rem, 1rem, 1.2rem);
  cursor: pointer;
`

export const Secondary = styled.button`
  background-color: ${(p: ButtonsProps) => (p.bg ? p.bg : "var(--color-rosa)")};
  color: ${(p: ButtonsProps) => (p.color ? p.color : "#fbfbfbf9")};
  border: none;
  border-radius: 52px;
  height: ${(p: ButtonsProps) => p.height || "65"}px;
  width: ${(p: ButtonsProps) => p.width + "px" || "100%"};
  font: normal normal bold 30px/37px MontserratRegular;
  font-size: clamp(0.9rem, 1rem, 1.2rem);
  cursor: pointer;
`

export const Simple = styled.button`
  background-color: ${(p: ButtonsProps) => (p.bg ? p.bg : "var(--color-rosa)")};
  color: ${(p: ButtonsProps) => (p.color ? p.color : "#fbfbfbf9")};
  border: none;
  border-radius: 52px;
  height: ${(p: ButtonsProps) => p.height || "65"}px;
  width: 100%;
  font-size: 26px;
  pointer-events: none;
  font: normal normal bold 30px/37px MontserratRegular;
`

export const AddCatalog = styled.button`
  background-color: ${(p: ButtonsProps) => (p.bg ? p.bg : "var(--color-rosa)")};
  color: ${(p: ButtonsProps) => (p.color ? p.color : "#fbfbfbf9")};
  border: none;
  width: 100%;
  border-radius: 52px;
  height: 2.7rem;
  width: fit-content;
  font-size: clamp(1.3rem, 2.5vw, 1rem);
  padding: 0 1.5rem;
  font-family: MontserratRegular;
`

export const AcceptCatalog = styled.button`
  background-color: #949392;
  color: ${(p: ButtonsProps) => (p.color ? p.color : "#fbfbfbf9")};
  display: ${(p: ButtonsProps) => (p.visible ? "block" : "none")};
  border: none;
  width: 100%;
  border-radius: 52px;
  height: 2.7rem;
  width: fit-content;
  font-size: clamp(1.3rem, 2.5vw, 1rem);
  padding-left: 2.5rem;
  padding-right: 2.5rem;
  margin-right: 1rem;
  margin-left: 1rem;
  font-family: MontserratRegular;
`

export const CancelCatalog = styled.button`
  background-color: #f15642;
  color: ${(p: ButtonsProps) => (p.color ? p.color : "#fbfbfbf9")};
  display: ${(p: ButtonsProps) => (p.visible ? "block" : "none")};
  border: none;
  width: 100%;
  border-radius: 52px;
  height: 2.7rem;
  width: fit-content;
  font-size: clamp(1.3rem, 2.5vw, 1rem);
  padding-left: 2.5rem;
  padding-right: 2.5rem;
  margin-right: 1rem;
  margin-left: 1rem;
  font-family: MontserratRegular;
`

export const PlusCatalog = styled.button`
  background-color: #0079ab;
  color: ${(p: ButtonsProps) => (p.color ? p.color : "#fbfbfbf9")};
  display: ${(p: ButtonsProps) => (p.visible ? "flex" : "none")};
  border: none;
  width: 100%;
  border-radius: 52px;
  height: 2.7rem;
  width: fit-content;
  font-size: clamp(1.3rem, 2.5vw, 1rem);
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  margin-right: 1rem;
  margin-left: 1rem;
  align-items: center;
  justify-items: center;
  font-family: MontserratRegular;
`

export const AcceptConfirmation = styled.button`
  background-color: #0079ab;
  color: ${(p: ButtonsProps) => (p.color ? p.color : "#fbfbfbf9")};
  display: ${(p: ButtonsProps) => (p.visible ? "block" : "none")};
  border: none;
  width: 100%;
  border-radius: 52px;
  height: 2.7rem;
  width: fit-content;
  font-size: clamp(1.3rem, 2.5vw, 1rem);
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  margin-right: 0.5rem;
  margin-left: 0.5rem;
  font-family: MontserratRegular;
`

export const CancelConfirmation = styled.button`
  background-color: #f15642;
  color: ${(p: ButtonsProps) => (p.color ? p.color : "#fbfbfbf9")};
  display: ${(p: ButtonsProps) => (p.visible ? "block" : "none")};
  border: none;
  width: 100%;
  border-radius: 52px;
  height: 2.7rem;
  width: fit-content;
  font-size: clamp(1.3rem, 2.5vw, 1rem);
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  margin-right: 0.5rem;
  margin-left: 0.5rem;
  font-family: MontserratRegular;
`
